import { APP_ICONS, AppIcon, type AppIconKey } from "~/components/app-icon";
import * as m from "~/paraglide/messages.js";

const TOOLS: AppIconKey[] = [
  "gmail",
  "microsoft",
  "slack",
  "hubspot",
  "notion",
  "googlesheets",
];

/**
 * The integration row. Product names are the content here, so they are not
 * translated — and the note under them is the honest part: what connects is
 * established before anything is proposed.
 */
export function Ecosystem() {
  return (
    <section aria-label={m.home_ecosystem_label()} className="ecosystem wrap">
      <p>{m.home_ecosystem_title()}</p>

      <div className="tool-row">
        {TOOLS.map((tool) => (
          <span key={tool}>
            <AppIcon name={tool} />
            {APP_ICONS[tool]}
          </span>
        ))}
      </div>

      <p className="integration-note">{m.home_ecosystem_note()}</p>
    </section>
  );
}
